module.exports = __webpack_public_path__ + "media/music.1db27df4.mp3";